<template>
  <v-tooltip nudge-left bottom>
    <template v-slot:activator="{ on }">
      <v-btn icon v-on="on">
        <v-icon :color="color" v-html="icon"/>
      </v-btn>
    </template>
    <span v-text="text"/>
  </v-tooltip>
</template>

<script>
import StatusService from '../../services/StatusService'
import LocalStorageService from '../../services/LocalStorageService'

export default {
  data: () => ({
    connected: false,
    secure: LocalStorageService.getAccessUrl()?.startsWith('https://')
  }),

  computed: {
    icon () {
      return this.secure
        ? this.connected ? 'mdi-check-circle' : 'mdi-close-circle'
        : 'mdi-alert'
    },
    color () {
      return this.connected
        ? this.secure ? 'white' : 'orange'
        : this.secure ? 'yellow' : 'red'
    },
    text () {
      return this.secure
        ? this.connected ? this.$t('appbar.secure_connected') : this.$t('appbar.secure_not_connected')
        : this.connected ? this.$t('appbar.unsecure_connected') : this.$t('appbar.unsecure_not_connected')
    }
  },

  methods: {
    connect () {
      this.secure = LocalStorageService.getAccessUrl()?.startsWith('https://')
      if (['/login', '/select-client'].includes(this.$router.currentRoute.fullPath)) {
        this.connected = false
      } else {
        StatusService.status()
          .then(res => { this.connected = res.data })
          .catch(() => { this.connected = false })
      }
    }
  },

  mounted () {
    this.connect()
    setInterval(this.connect, 10000)
  }
}
</script>

<style>

</style>
